import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

export const apiConfig = {
  GetAuctions: BOM.baseUrl("auctions", "treasury"),
};

export const labelConfig = {
  auction: "Auction",
  auctionListing: "Auction Listing",
  addAuction: "Create New Aution",
  editAuction: "Edit Auction",
  viewAuction: "",

  trade: "Trade",
  tradeListing: "Trade Listing",
  addTrade: "Create New Trade",
  editTrade: "Edit Trade",

  settlement:"Settlement",
  settlementListing:"Settlement Listing",
  addSettlement:"Settlement Listing",
  editSettlement:"Edit Settlement",
  viewSettlement:"View Settlement",

  treasuryBillContract:"Treasury Bill Contract",
  treasuryBillContractListing:"Treasury Bill Contract Listing",
  addTreasuryBillContractListing:"Create Treasury Bill Contract Listing",

  manageBondContract:"Bond Contract",
  bondContractListing:"Bond Contract Listing",
  addBondContractListing:"Add Treasury Bill Contract Listing",

};

export const staticConfig = {
  manageAuction: [{ title: labelConfig.auction }],
  newAuction: [
    { title: <Link to="/auction">{labelConfig.auction}</Link> },
    {
      title: labelConfig.addAuction,
    },
  ],

  manageTrade: [{ title: labelConfig.trade }],
  newTrade:[
    { title: <Link to="/trade">{labelConfig.trade}</Link> },
    {
      title: labelConfig.addTrade,
    },
  ],
  
  manageSettlement: [{ title: labelConfig.settlement }],
  newSettlement:[
    { title: <Link to="/settlement">{labelConfig.settlement}</Link> },
    {
      title: labelConfig.addSettlement,
    },
  ],
  
  managetreasuryBillContract: [{ title: labelConfig.addTreasuryBillContractListing }],
  newtreasuryBillContract:[
    { title: <Link to="/treasury-bill-contract">{labelConfig.addTreasuryBillContractListing}</Link> },
    {
      title: labelConfig.addSettlement,
    },
  ],
  
  manageBondContract: [{ title: labelConfig.manageBondContract }],
  newBondContract:[
    { title: <Link to="/bond-contract">{labelConfig.addBondContractListing}</Link> },
    {
      title: labelConfig.addSettlement,
    },
  ]
  
};
